<template>
  <v-card>
    <v-form @submit="submit" onSubmit="return false;">
      <v-card-title class="headline py-2">
        Пригласить пользователя на пост {{post.title}}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog" class="mx-0"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      
      <v-card-text>
        <p class="pa-0 ma-0" v-if="emailsList.length>0">Отправленные приглашения:</p>
    
        <v-list>
          <v-list-tile v-for="(email, index) in emailsList" :key="index">
            <v-list-tile-action>
              <span class="caption green--text mr-2" v-if="email.status===0">Отправлено</span>
              <span class="caption red--text mr-2" v-else-if="email.status===1">Отклонено</span>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{email.email}}</v-list-tile-title>
            </v-list-tile-content>
            <v-btn color="error" small class="pull-right" @click="deleteInvite(index)">Отменить</v-btn>
          </v-list-tile>
        </v-list>
    
        <v-progress-linear :indeterminate="true" v-if="pending"></v-progress-linear>
    
        
          <v-text-field
            v-model="email"
            label="Добавить кандидата по E-mail"
            :error-messages="veeErrors.collect('email')"
            v-validate="'required|email'"
            data-vv-name="email"
            required
          ></v-text-field>
      
          <v-textarea v-model="message" label="Сообщение кандидату" rows="3" auto-grow></v-textarea>
        
      </v-card-text>
      
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn color="success" type="submit" :disabled="status.btnDisabled">Отправить приглашение</v-btn>
        <span :class="status.className" class="ml-2">{{status.text}}</span>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  export default {
    name: 'InviteForm',

    props:{
      invites:{
        type: Array,
        default: ()=>[],
        required: true
      },
      post:{
        type: Object,
        required: true,
        default: () => ({ id: '', name: ''}),
      }
    },

    computed:{
      emailsList(){
        return this.invites
      }
    },

    data() {
      return {
        email: '',
        message: '',
        status:{
          btnDisabled: false,
          text: '',
          className: 'success--text darken-1'
        },
        pending: false,
      }
    },

    methods:{
      submit(e){
        e.preventDefault()
        this.$validator.validateAll().then( result => {
          if (result) {
            this.status={ btnDisabled: true, text: 'Отправка', className:'secondary--text lighten-1' }
            this.pending = true
            this.$store.dispatch('orgstructure/createInvite', { email: this.email,  post_id: this.post.key, message: this.message  }).then( response => {
              this.emailsList.push(response.invite_data)
              this.email = ''
              this.$nextTick(() => this.$validator.reset())
              this.pending = false
              this.status={ btnDisabled: false, text: 'Отправлено', className:'success--text darken-1' }
            }).catch( error => {
              this.pending = false
              this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
            })
            return false
          }
        })
        return false
      },
  
      deleteInvite(index){
        this.$store.dispatch('orgstructure/deleteInvite', this.emailsList[index].id).then( response => {
          this.emailsList.splice(index, 1)
        })
      },
      
      closeDialog(){
        this.$emit('close-dialog')
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Orgschema/Forms/InviteForm.vue